<template>
  <div class="infinity-loading">
    <div class="loading-track">
      <div class="loading-slider" />
    </div>
  </div>
</template>

<script>
export default {
  name: "InfinityLoading",
};
</script>

<style scoped lang="scss">
.infinity-loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-track {
  display: flex;
  width: 361px;
  height: 15px;
  align-items: center;
  border-radius: 20px;
  background: var(--colors-purple-50, #ede5ff);
  position: relative;
  overflow: hidden;
}

.loading-slider {
  position: absolute;
  left: 0;
  border-radius: 20px;
  background: linear-gradient(
    90deg,
    var(--colors-purple-300, #be95ff) 0%,
    var(--colors-purple-500, #8a3ffc) 100%
  );
  width: 101px;
  height: 15px;
  animation: slide 1.8s ease-in-out infinite alternate;
}

@keyframes slide {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(260px);
  }
}
</style>
